import _ from 'lodash'
import axios from 'axios'
import Cookies from 'js-cookie'
// import plyr from 'plyr'
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import GoogleMapsLoader from 'google-maps'

import VueDjangoCMSPatch from './plugins/vue-djangocms-patch'

import TheContent from './components/TheContent'
import TheHeader from './components/TheHeader'
import TheFooter from './components/TheFooter'
import CookieLaw from './components/CookieLaw'
import Newsletter from './components/Newsletter'

import Appear from './library/appear'
Vue.directive(Appear.name, Appear)

import { GOOGLE_API_KEY } from './constants'
import { DURATION } from './constants'

// Styles
import 'vue-multiselect/dist/vue-multiselect.min.css'
import '../sass/style.scss'

// Configure CSRF token.
Cookies.set('csrftoken', CSRF_TOKEN, {expires: 1})
axios.defaults.headers.post['X-CSRFToken'] = CSRF_TOKEN

// Set ignored elements as required by vue-djangocms-patch.
Vue.config.ignoredElements = ['cms-template', 'cms-plugin']

// Configure GoogleMaps.
GoogleMapsLoader.KEY = GOOGLE_API_KEY;

// Enable 3rd party packages.
Vue.component('multiselect', Multiselect)

// Main Vue instance.
var app = new Vue({
  el: '#app',
  components: {
    TheHeader,
    TheContent,
    TheFooter,
    CookieLaw,
    Newsletter,
  },

  data: {
    windowLoaded: false,
    contentLoaded: false,
    minLoadTimeElapsed: false,
    minLoadTime: 200,
    disableScroll: false,
  },

  computed: {
    loaded: function () { return this.windowLoaded && this.minLoadTimeElapsed; },
  },
  watch: {
    loaded: function (newValue) {
      if (newValue) {
        var vm = this;
        setTimeout(function () { vm.contentLoaded = true; }, DURATION * 500);
      }
    },
    disableScroll: function (newValue) {
      if (newValue) { document.body.style.overflow = 'hidden'; }
      else { document.body.style.removeProperty('overflow'); }

      if (newValue) { document.body.style.scrolling = 'touch'; }
      else { document.body.style.removeProperty('scrolling'); }

    }
  },

  created () {
    // Patch DjangoCMS.
    new VueDjangoCMSPatch(this)
  },

  mounted: function () {
    var vm = this;
    window.onload = function () { vm.windowLoaded = true; }
    _.delay(function () { vm.minLoadTimeElapsed = true }, vm.minLoadTime);
  }
})



// WEBPACK FOOTER //
// ./assets/js/main.js